import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducers(organization_id, current_page) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/fetch_producers/${current_page}`
    );
  },
  filterProducers(organization_id, filters) {
    var str = Object.keys(filters)
      .filter(key => filters[key] != null)
      .filter(key => filters[key] != "")
      .map(key => {
        return `${key}=${encodeURIComponent(filters[key])}`
      })
      .join("&");
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/filter_producers?${str}`
    );
  },
  fetchCertifications(organization_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/fetch_certifications`
    );
  },
  downloadReport(organization_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/download_report`,
      { responseType: "blob" }
    );
  },
};
